import { useRouter } from "next/router";
import React from "react";
import Cookies from "js-cookie";
import NavbarLayout from "components/Layout/NavbarLayout";
import MetaTags from "components/MetaTags/MetaTags";
import ReferralModal from "components/Referral/ReferralModal/ReferralModal";
import MetaSite from "components/MetaTags/MetaSite";
import { GetServerSideProps } from "next";
import MetaImage from "components/MetaTags/MetaImage";
import getBaseUrl from "@tiicker/util/lib/get-base-url";
import FooterV2 from "components/FooterV2/FooterV2";
import NavigationBar from "components/Global/Navigation/NavigationBar/NavigationBar";

interface Props {
  code: String;
}

const Refer = (props: Props) => {
  const router = useRouter();
  const { code } = props;

  if (code) {
    Cookies.set("referralCode", code);
  }

  const closeReferralModal = () => {
    router.push("/");
  };

  return (
    <>
      <MetaTags
        title="You should check out TiiCKER!"
        description="Referring a friend to TiiCKER has its rewards. Learn more today."
      />
      <MetaSite partialUrl={`/refer/${code}`} />
      <MetaImage
        image={`${getBaseUrl()}images/referral-share-image.png`}
        imageAlt="Referring a friend to TiiCKER has its rewards. Learn more today."
      />
      <NavigationBar />
      <ReferralModal
        visible={true}
        onClose={closeReferralModal}
        message="Looks like you were referred by a friend."
      />
    </>
  );
};

export const getServerSideProps: GetServerSideProps<Props> = async ({
  params,
}) => {
  if (!params || !params.code || Array.isArray(params.code)) {
    return {
      props: {
        code: "",
      },
    };
  }

  return {
    props: {
      code: params.code,
    },
  };
};

export default Refer;
